import axios from 'axios'
import debounce from 'lodash.debounce'
import { mapState, mapActions, mapMutations } from 'vuex'
import MainTable from '@/components/main-table/main-table.vue'
import MainMap from '@/components/main-map/main-map.vue'
import StatPanel from '@/components/stat-panel/stat-panel.vue'
import escPressPagesWithMap from '@/pages/mixins/escPressPagesWithMap'

export default {
  name: 'Main',
  components: {
    MainTable,
    MainMap,
    StatPanel
  },
  /**
   * escPressPagesWithMap - переход назад по esc
   */
  mixins: [escPressPagesWithMap],
  static() {
    return {
      timeoutUpdate: null,
      timeUpdate: 10000
    }
  },
  data() {
    return {
      tableLoading: false
    }
  },
  computed: {
    ...mapState({
      pageLoading: state => state.pageLoader.loading,
      orders: state => state.orders.orders,
      ordersFilters: state => state.orders.filters,
      orderPayments: state => state.orders.orderPayments,
      ordersByStatuses: state => {
        const result = { ...state.orders.ordersByStatuses }
        delete result.total
        return result
      },
      allowedOrdersFilters: state => state.orders.allowedOrdersFilters
    })
  },
  beforeDestroy() {
    this.setEditedRouteTask([])
    this.setEditedRouteTaskInfo(null)
    this.cancelUpdateMainInfo()
  },
  methods: {
    ...mapActions({
      getMainInfo: 'orders/getMainInfo',
      cancelMainInfo: 'orders/cancelMainInfo'
    }),
    ...mapMutations({
      setEditedRouteTask: 'routeTasks/SET_EDITED_ROUTE_TASK',
      setEditedRouteTaskInfo: 'routeTasks/SET_EDITED_ROUTE_TASK_INFO',
      setFilters: 'orders/SET_FILTERS'
    }),

    onSortChange(event) {
      const sortObj = event[0]
      let stringSort = sortObj.field.replace(/\./g, '__')
      if (sortObj.type === 'desc') {
        stringSort = `-${stringSort}`
      }

      this.setFilters({
        ...this.ordersFilters,
        sort: stringSort
      })
    },
    prepareFilters() {
      const filters = { ...this.ordersFilters }

      if (filters.auto_routetask && filters.auto_routetask.length === 1) {
        filters.auto_routetask = filters.auto_routetask[0].value
      } else {
        delete filters.auto_routetask 
      }

      return filters
    },
    async getInfoWithLoading() {
      /**
       * Отдельно не через setUpdateTimeout,
       * потому что поставим первоначальный лоадер
       */
      this.tableLoading = true
      try {
        await this.getMainInfo(this.prepareFilters())
        this.tableLoading = false
        this.timeoutUpdate = window.setTimeout(() => {
          this.setUpdateTimeout()
        }, this.timeUpdate)
      } catch (e) {
        if (!(e instanceof axios.Cancel)) {
          this.setUpdateTimeout()
          this.tableLoading = false
        }
      }
    },

    setUpdateTimeout() {
      this.getMainInfo(this.prepareFilters())
        .then(() => {
          this.timeoutUpdate = window.setTimeout(() => {
            this.setUpdateTimeout()
          }, this.timeUpdate)
        })
        .catch(() => {
          this.timeoutUpdate = window.setTimeout(() => {
            this.setUpdateTimeout()
          }, this.timeUpdate)
        })
    },

    cancelUpdateMainInfo() {
      window.clearTimeout(this.timeoutUpdate)
      this.timeoutUpdate = null
      this.cancelMainInfo()
    },

    onChangeOrdersFilters: debounce(function () {
      this.cancelUpdateMainInfo()
      this.getInfoWithLoading()
    }, 300),

    /**
     *
     * @param {String[]} statusFilter
     */
    onSetStatusFilter(statusFilter) {
      this.setFilters({
        ...this.ordersFilters,
        statuses: statusFilter
      })
    }
  },
  watch: {
    ordersFilters() {
      this.onChangeOrdersFilters()
    }
  }
}
